<template>
  <div>
    <div class="col-12 text-center mb-5" v-if="tempoValido == true">
      <h3 class="c-orange">Promoção expira em:</h3>
      <flip-countdown
        :deadline="tempo"
        countdownSize="2rem"
        labelSize="1rem"
        :labels="{
          days: 'Dias',
          hours: 'Hrs.',
          minutes: 'Min.',
          seconds: 'Seg.'
        }"
      >
      </flip-countdown>
    </div>
    <!-- Special Register -->
    <hr v-if="!specialRegister && !referencia && gerente == false" />
    <h4 v-if="!specialRegister && !referencia && gerente == false && dadosPlano == null">
      Foi pré-cadastrado? Clique
      <span
        @click="specialRegister = true"
        style="color: #ec640c; cursor: pointer"
        >aqui</span
      >
      e faça seu registro com mais agilidade!
    </h4>
    <h4 v-if="dadosPlano != null">
      {{dadosPlano.nome}}
    </h4>

    <ShopkeeperSpecialRegister
      class="p-5"
      v-if="specialRegister || (referencia && isSpecialRegistering)"
      v-on:found="logger"
      v-on:commonregister="specialRegister = false"
      :referencia="this.referencia"
    />

    <hr v-if="!specialRegister && !referencia" />
    <div v-if="partnerId" class="text-center rounded">
      <h5 class="c-orange">
        Você está se cadastrando pelo vendedor {{ affiliateName }}
      </h5>
    </div>
    <div v-if="!specialRegister && !isSpecialRegistering" class="row col-12">
      <div class="planos" v-if="gerente == false && mostrarPlano == true">
        <div class="card-plano">
          <div
            class="card-header position-relative text-uppercase font-weight-bold text-center fs-22"
          >
            <label class="checktainer c-pointer m-0">
              <input
                type="radio"
                name="plano"
                class="plano-checkbox"
                value="3"
                v-model="Fields.plano"
                @input="ErrorMessages.paymentPlan = null"
                required
              />
              Plano
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="fs-20 text-center text-uppercase">4,0% da venda</div>
            <div class="fs-14 text-center p-4px">pela Plataforma</div>
            <div class="fs-14 text-center p-4px" >* Pagamento mínimo mensal de <br> 
            {{ planosApp[0] && planosApp[0].preco }} descontado da comissão.
            </div>
          </div>
          <div class="card-footer p-5px">
            <div
              class="w-100 c-pointer btn btn-aceitar-contrato"
              @click="showContratoPlano('contrato-lojista-plano-pagamento')"
            >
              Ver e aceitar o contrato
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="videoYoutube" v-if="gerente == false">
        <div class="justify-content-center">
          <div class="cont-video">
            <div class="box-video">
              <iframe
                width="500"
                height="250"
                src="https://www.youtube.com/embed/LEeqm8YaDG8"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              >
              </iframe>
            </div>
          </div>
        </div>
      </div> -->

      <div class="col-12">
        <p
          class="error-message text-danger"
          v-if="ErrorMessages.paymentPlan !== null"
        >
          {{ ErrorMessages.paymentPlan }}
        </p>
      </div>
      <ShopKeeperPaymentPlan />
      <div class="col-12  mb-2">
        <div class="form-group">
          <label for="segmentos">
            <div :class="gerente == false ? 'fs-18 mt-4' : 'fs-18'">
              <span>
                Segmentos da loja *
              </span>
              <span class="ml-5">
                <button 
                  class="btn bg-orange c-white"
                  @click="$refs.modalSelectSegment.toggleOpen({ 
                    segment: segmentos 
                  })"
                >
                <i class="fas fa-plus mr-2"></i> Adicionar Segmento
                </button>
              </span>
            </div>
            <div class="fs-14 m-0 p-0 mb-2">
              (Adicione o(s) segmento(s) que deseja receber seus orçamentos)
            </div>
          </label>
          <div class="row" id="segmentos" >
            <div 
              v-if="ErrorMessages.segmentos !== null"
              class="container"
            >
              <p
                class="error-message text-danger"    
              >
                {{ ErrorMessages.segmentos }}
              </p>
            </div>
            <div v-else class="col-12">
              <div>
                <span
                  v-if="Fields.segmentos.length ==  0"
                  class="border p-1 mb-5 bg-warning p-1"
                >
                  Favor selecionar ao menos um segmento
                </span>
                <span
                    v-else
                  v-for="(segmento, index) in Fields.segmentos"
                  class="py-1 pr-2"
                  >
                  <button disabled class="p-1 btn btn-outline-primary ">
                    {{ getNameSegment(segmento) }}
                  </button>
                </span>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <ModalSelectSegment
        ref="modalSelectSegment"
        @addSegment="addSegmentoLojista($event)"
      />
      <div class="col-lg-6">
        <div class="form-group">
          <label for="cadastroRazaoSocial"> Razão Social *</label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.razao_social"
            id="cadastroRazaoSocial"
            aria-describedby="Razão Social para cadastro da empresa"
            placeholder="Digite a razão social da empresa"
            @input="ErrorMessages.companyName = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.companyName !== null"
          >
            {{ ErrorMessages.companyName }}
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="cadastroNomeFantasia"> Nome Fantasia *</label>
          <input
            type="text"
            v-model="Fields.nome_fantasia"
            class="form-control"
            id="cadastroNomeFantasia"
            aria-describedby="Nome Fantasia para cadastro da empresa"
            placeholder="Digite o nome fantasia da empresa"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.fantasyName !== null"
          >
            {{ ErrorMessages.fantasyName }}
          </p>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="cadastroNomeResponsavel"> Nome Responsável *</label>
          <input
            type="text"
            v-model="Fields.nome_responsavel"
            class="form-control"
            id="cadastroNomeResponsavel"
            aria-describedby="Nome do Responsável para cadastro da empresa"
            placeholder="Digite o nome do Responsável da empresa"
            @input="ErrorMessages.responsibleName = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.responsibleName !== null"
          >
            {{ ErrorMessages.responsibleName }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroCnpj"> CNPJ *</label>
          <input
            type="text"
            v-model="Fields.cnpj"
            class="form-control"
            id="cadastroCnpj"
            v-mask="'##.###.###/####-##'"
            aria-describedby="CNPJ para cadastro da empresa"
            placeholder="Digite o CNPJ da empresa"
            @input="ErrorMessages.cnpj = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cnpj !== null"
          >
            {{ ErrorMessages.cnpj }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroCelular"> WhatsApp *</label>
          <input
            type="text"
            v-model="Fields.celular"
            class="form-control"
            id="cadastroCelular"
            v-mask="['(##) #####-####', '(##) ####-####']"
            aria-describedby="Celular para cadastro da empresa"
            placeholder="Digite o celular da empresa"
            @input="ErrorMessages.cellPhone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cellPhone !== null"
          >
            {{ ErrorMessages.cellPhone }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroTelefone"> Telefone *</label>
          <input
            type="text"
            v-model="Fields.telefone"
            class="form-control"
            id="cadastroTelefone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Telefone para cadastro da empresa"
            placeholder="Digite o telefone da empresa"
            @input="ErrorMessages.telephone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone !== null"
          >
            {{ ErrorMessages.telephone }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroTelefone"> Telefone 2</label>
          <span class="opc">Opcional</span>
          <input
            type="text"
            v-model="Fields.telefone2"
            class="form-control"
            id="cadastroTelefone2"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Telefone para cadastro da empresa"
            placeholder="Digite o telefone 2 da empresa"
            @input="ErrorMessages.telephone2 = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone2 !== null"
          >
            {{ ErrorMessages.telephone2 }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12">
        <TextAddress class="d-flex justify-content-center" />
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroCep"> CEP *</label>
          <span class="location" @click="getCurrentLocation()">
            <i class="fas fa-location-arrow mr-2"></i>Usar minha localização
          </span>
          <input
            type="text"
            v-model="Fields.cep"
            class="form-control"
            id="cadastroCep"
            v-mask="'#####-###'"
            aria-describedby="CEP para cadastro da empresa"
            placeholder="Digite o CEP da empresa"
            @input="ErrorMessages.cep = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cep !== null"
          >
            {{ ErrorMessages.cep }}
          </p>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="cadastroEndereco"> Endereço *</label>
          <input
            type="text"
            v-model="Fields.endereco"
            class="form-control"
            id="cadastroEndereco"
            aria-describedby="Endereço para cadastro da empresa"
            placeholder="Digite o endereço da empresa"
            @input="ErrorMessages.address = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidAddress)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroNumero"> Número *</label>
          <input
            type="text"
            v-model="Fields.numero"
            class="form-control"
            id="cadastroNumero"
            aria-describedby="Número para cadastro da empresa"
            placeholder="Digite o número da empresa"
            @input="ErrorMessages.number = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number !== null"
          >
            {{ ErrorMessages.number }}
          </p>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="cadastroComplemento"> Complemento </label>
          <span class="opc">Opcional</span>
          <input
            type="text"
            v-model="Fields.complemento"
            class="form-control"
            id="cadastroComplemento"
            aria-describedby="Complemento para cadastro da empresa"
            placeholder="Digite o complemento da empresa"
            @input="ErrorMessages.complement = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.complement !== null"
          >
            {{ ErrorMessages.complement }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-12">
        <div class="form-group">
          <label for="cadastroBairro"> Bairro *</label>
          <input
            type="text"
            v-model="Fields.bairro"
            class="form-control"
            id="cadastroBairro"
            aria-describedby="Bairro para cadastro da empresa"
            placeholder="Digite o bairro da empresa"
            @input="ErrorMessages.neighborhood = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidNeighborhood)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cadastroCidade"> Cidade *</label>
          <v-select
            disabled
            id="cidade_id"
            name="cidade_id"
            placeholder="Selecione a cidade da empresa"
            label="nome"
            autocomplete="nope"
            class="no-search"
            v-model="Fields.cidade_id"
            :key="Fields.cidade_id"
            :options="getCities"
            :reduce="(city) => city.id"
            @input="ErrorMessages.city = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city !== null"
          >
            {{ ErrorMessages.city }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cadastroEstado"> Estado *</label>
          <v-select
            disabled
            id="estado_id"
            name="estado_id"
            placeholder="Selecione o estado da empresa"
            label="nome"
            autocomplete="nope"
            class="no-search"
            v-model="Fields.estado_id"
            :key="Fields.estado_id"
            @input="ErrorMessages.estado_id = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.estado_id !== null"
          >
            {{ ErrorMessages.estado_id }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12 mb-3 c-orange fs-24 d-flex justify-content-center">
        <span class="font-weight-bold text-center mb-3 c-orange">
          Contato do financeiro
          <i class="fas fa-file-invoice-dollar ml-2"></i>
        </span>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroNomeFinanceiro"> Nome do Responsável *</label>
          <input
            type="text"
            v-model="Fields.nome_financeiro"
            class="form-control"
            id="cadastroNomeFinanceiro"
            aria-describedby="Nome do responsável financeiro para cadastro da empresa"
            placeholder="Digite o nome do responsável financeiro da empresa"
            @input="ErrorMessages.name_financial = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.name_financial !== null"
          >
            {{ ErrorMessages.name_financial }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroEmailFinanceiro"> Email do Responsável *</label>
          <input
            type="text"
            v-model="Fields.email_financeiro"
            class="form-control"
            id="cadastroEmailFinanceiro"
            aria-describedby="Email do responsável financeiro para cadastro da empresa"
            placeholder="Digite o e-mail do responsável financeiro da empresa"
            @input="ErrorMessages.email_financial = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email_financial !== null"
          >
            {{ ErrorMessages.email_financial }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroNumeroFinanceiro"> Telefone / Celular *</label>
          <input
            type="text"
            v-model="Fields.numero_financeiro"
            class="form-control"
            id="cadastroNumeroFinanceiro"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Número do responsável do financeiro para cadastro da empresa"
            placeholder="Digite o número do responsável financeiro da empresa"
            @input="ErrorMessages.number_financial = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number_financial !== null"
          >
            {{ ErrorMessages.number_financial }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroRamalFinanceiro"> Ramal </label>
          <span class="opc">Opcional</span>
          <input
            type="text"
            v-model="Fields.ramal_financeiro"
            class="form-control"
            id="cadastroRamalFinanceiro"
            v-mask="['########', '#########']"
            aria-describedby="Ramal do responsável do financeiro para cadastro da empresa"
            placeholder="Digite o ramal do responsável financeiro da empresa"
            @input="ErrorMessages.ramal_financial = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.ramal_financial !== null"
          >
            {{ ErrorMessages.ramal_financial }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12 c-orange d-flex justify-content-center">
        <TextAccess class="d-flex justify-content-center" />
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="cadastroEmail"> E-mail *</label>
          <input
            type="text"
            v-model="Fields.email"
            @blur="validEmail()"
            class="form-control"
            id="cadastroEmail"
            aria-describedby="Email para cadastro da empresa"
            placeholder="Digite um E-mail para acessar a plataforma"
            @input="ErrorMessages.email = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email !== null"
          >
            {{ ErrorMessages.email }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6" v-if="gerente == false">
        <div class="form-group">
          <InputPassword
            :label="'Senha *'"
            :value.sync="Fields.password"
            :errorMessage.sync="ErrorMessages.password"
          />
        </div>
      </div>
      <div class="col-12 col-md-6" v-if="gerente == false">
        <InputPassword
          :label="'Confirme sua senha *'"
          :value.sync="Fields.confirm_senha"
          :errorMessage.sync="ErrorMessages.confirm_password"
          :placeholder="'Digite novamente a sua senha'"
        />
      </div>

      <div class="col-md-2 form-group mb-0 pb-0" v-if="gerente == false">
        <label class="font-weight-bold">Cód. gerente:</label>
        <span class="opc">Opcional</span>
        <input
          type="text"
          class="form-control"
          v-model="gerenteVendas.cod"
          placeholder="####"
          :disabled="blurGerente"
          @blur="buscarGerenteBlur()"
        />
      </div>

      <div class="col-md-3 form-group mb-0 pb-0" v-if="gerente == false">
        <label for="email" class="font-weight-bold">Nome:</label>
        <span class="opc">Opcional</span>
        <input
          type="text"
          class="form-control"
          v-model="gerenteVendas.nome"
          placeholder="Nome gerente de conta"
          disabled
        />
      </div>

      <div class="col-md-3 form-group mb-0 pb-0" v-if="gerente == false">
        <label class="font-weight-bold">E-mail:</label>
        <span class="opc">Opcional</span>
        <input
          type="text"
          class="form-control"
          v-model="gerenteVendas.email"
          placeholder="E-mail gerente de conta"
          disabled
        />
      </div>

      <div class="col-md-2 form-group mb-0 pb-0" v-if="gerente == false">
        <label class="font-weight-bold">Telefone:</label>
        <span class="opc">Opcional</span>
        <input
          type="text"
          class="form-control"
          v-model="gerenteVendas.telefone"
          placeholder="(##) ####-####"
          disabled
          v-mask="['(##) ****-####', '(##) * ****-####']"
        />
      </div>

      <div class="col-md-2 form-group mb-0 pb-0" v-if="gerente == false">
        <label class="font-weight-bold">WhatsApp:</label>
        <span class="opc">Opcional</span>
        <input
          type="text"
          class="form-control"
          v-model="gerenteVendas.whatsapp"
          placeholder="(##) # ####-####"
          disabled
          v-mask="['(##) ****-####', '(##) * ****-####']"
        />
      </div>

      <div class="col-12 col-md-12 mt-3">
        <div class="form-group d-flex justify-center mb-0 pb-0" v-if="gerente == false">
          <b-form-checkbox
            id="termoConfirmacao"
            name="termoConfirmacao"
            v-model="acceptedTermsAndConditions"
            @input="ErrorMessages.confirmationTerm = null"
            required
          >
          </b-form-checkbox>

          <div class="font-weight-normal">
            Li e aceito os
            <span class="c-orange c-pointer" v-b-modal="'termos'"
              >termos e condições</span
            >
            e as
            <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
              >politicas de privacidade.</span
            >
          </div>

          <p
            class="error-message text-danger"
            v-if="ErrorMessages.confirmationTerm !== null"
          >
            {{ ErrorMessages.confirmationTerm }}
          </p>
        </div>
         <span class="obgt">
          Campos obrigatórios! (*)
        </span>
        <div class="form-group text-center">
          <button
            variant="primary"
            type="submit"
            class="btn bg-orange c-white text-uppercase btn-larg mt-2"
            :disabled="!isValidReq && !isValidEmail"
            @click="register()"
          >
            <i class="fas fa-save mr-2"></i>Cadastrar
          </button>
        </div>
      </div>
    </div>

    <SolicitateAppModal ref="solicitateAppModal" @success="delayedLogin()" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import makeToast from '../../mixins/makeToast';
import login from '../../mixins/login';
import UserTypes from '../../enums/UserTypes';
import ShopKeeperPaymentPlan from '../../components/PaymentPlanContract.vue';
import TextAccess from '../../components/Register/TextAccess.vue';
import TextAddress from '../../components/Register/TextAddress.vue';
import InputPassword from '../../components/Inputs/InputPassword.vue';
import ShopkeeperSpecialRegister from '../ShopkeeperSpecialRegister.vue';
import SolicitateAppModal from './new-app/SolicitateAppModal.vue';
import ModalSelectSegment from './ModalSelectSegment.vue';
import FlipCountdown from 'vue2-flip-countdown';
import Axios from 'axios';

export default {
  name: 'ShopkeeperRegister',
  mixins: [makeToast, login],
  data() {
    return {
      UserTypes,
      dadosPlano: null,
      planosApp: '',
      affiliateName: '',
      acceptedPrivacyPolicy: false,
      tempoValido: false,
      tempo: '2023-06-23 00:00:00',
      isValidReq: false,
      isValidEmail: false,
      acceptedTermsAndConditions: false,
      validGerente: false,
      blurGerente: false,
      gerenteVendas: {
        nome: null,
        email: null,
        telefone: null,
        whatsapp: null,
        cod: null,
      },
      data: {
        latitude: null,
        longitude: null
      },
      Fields: {
        segmentos: [],
        razao_social: '',
        nome_fantasia: '',
        nome_responsavel: '',
        cnpj: '',
        celular: '',
        telefone: '',
        telefone2: '',
        endereco: '',
        numero: '',
        complemento: '',
        cep: '',
        bairro: '',
        cidade_id: null,
        estado_id: null,
        nome_financeiro: '',
        email_financeiro: '',
        numero_financeiro: '',
        ramal_financeiro: '',
        // tipo_pagamento: null,
        email: '',
        password: '',
        confirm_senha: '',
        // data_vencimento: null,
        plano: '',
        plano_id: null,
        link_referencia: null,
        gerente: false,
        novoApp: false,
        planoIdValid: false,
        gerenteId: null,
        cadGerente: false,
      },
      ErrorMessages: {
        segmentos: null,
        companyName: null,
        fantasyName: null,
        responsibleName: null,
        cnpj: null,
        cellPhone: null,
        telephone: null,
        telephone2: null,
        address: null,
        number: null,
        complement: null,
        cep: null,
        neighborhood: null,
        city: null,
        estado_id: null,
        name_financial: null,
        email_financial: null,
        number_financial: null,
        ramal_financial: null,
        payment_type: null,
        email: null,
        confirmationTerm: null,
        privacyPolicy: null,
        paymentPlan: null,
        password: null,
        confirm_password: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      mostrarPlano: false,
      loading: false,
      specialRegister: false,
      referencia: null,
      isSpecialRegistering: false,
      registerFromItemMenu: false,
      info: [],
    };
  },
  props: {
    partnerId: {
      type: Number,
    },
    gerente: {
      type: Boolean,
      default: false,
      require: false,
    },
    gerenteId: {
      type: Number,
      default: null,
      require: false,
    },
  },
  components: {
    ShopKeeperPaymentPlan,
    TextAccess,
    TextAddress,
    InputPassword,
    ShopkeeperSpecialRegister,
    SolicitateAppModal,
    ModalSelectSegment,
    FlipCountdown
  },
  computed: {
    ...mapGetters('general', ['getCities']),
    ...mapState([
      'tipoUsuarios',
      'estados',
      'cidades',
      'planos',
      'segmentos',
      'dadosUsuario',
    ]),
  },
  created() {

    if (this.$route.query.value) {
      this.tempo = atob(this.$route.query.value);
      this.tempoValido = true;
    }

    if (this.$route.query.gerente) {
      this.buscarGerente();
    }

    if (this.$route.query.novoApp && this.$route.query.novoApp == 'solicitar-app') {
      this.Fields.novoApp = true;
      this.Fields.plano = 3;
      this.validAceite = false;
    }

    if (this.$route.query.plano && this.$route.query.plano != '') {
      this.mostrarPlano = true;
      this.Fields.plano_id = this.$route.query.plano;
      this.Fields.plano = '';
      this.showPlanosId();
    } else {
      this.mostrarPlano = false;
      this.Fields.plano = 3;
    }

    if (this.$route.name == 'cadastro-lojista') {
      this.blurGerente = true;
    }

    if (this.partnerId) {
      this.getName(this.partnerId).then((response) => {
        this.affiliateName = response.data.name;
      });
    }

    if (this.$route.query.referencia) {
      this.referencia = this.$route.query.referencia;
      this.isSpecialRegistering = true;
    }
  },
  mounted() {
    const { from } = this.$route.query || {};
    this.registerFromItemMenu = from === 'menu-item';
  },
  watch: {
    'Fields.cep': function () {
      this.consultCep();
    },
    'Fields.cnpj': function () {
      if (this.Fields.cnpj.length == 18) {
        this.validarCnpj();
      }
    },
  },
  methods: {
    ...mapActions('affiliate', ['getName']),
    buscarPlano() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarPlano', this.Fields.plano_id)
        .then((response) => {
          this.dadosPlano = response.data.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader')
        });
    },
    async getCurrentLocations() {
      navigator.geolocation.getCurrentPosition(async (res) => {
        this.data.latitude = res.coords.latitude;
        this.data.longitude = res.coords.longitude;
      });
    },
    getCurrentLocation(){
      if (navigator.geolocation){
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        this.makeToast('Oopss', 'Seu navegador não suporta Geolocalização.', 'danger');
      }
    },
    async showPosition(position){
      this.data.latitude = position.coords.latitude;
      this.data.longitude = position.coords.longitude;
      await this.populateMap();
    },
    showError(error) { 
      switch(error.code)
        {
        case error.PERMISSION_DENIED:
          this.makeToast('Oopss', 'Permita a Geolocalização em seu navegador.', 'danger');
          break;
        case error.POSITION_UNAVAILABLE:
          this.makeToast('Oopss', 'Localização indisponível.', 'danger');
          break;
        case error.TIMEOUT:
          this.makeToast('Oopss', 'A requisição expirou.', 'danger');
          break;
        case error.UNKNOWN_ERROR:
          this.makeToast('Oopss', 'Algum erro desconhecido aconteceu.', 'danger');
          break;
        }
    },
    async populateMap() {
      const response = await this.getCitiesByCoords();
      const data = response.components;

      if (!data.postcode) {
        this.makeToast('Oopss', 'Sem dados do CEP', 'danger');
        return;
      }

      this.Fields.cep = data.postcode;
    },
    async getCitiesByCoords() {
      if (!this.data.latitude || !this.data.longitude) return {};

      const queryString = `${this.data.latitude}+${this.data.longitude}`;

      const getCitiesResponse = await Axios.get(
        `https://api.opencagedata.com/geocode/v1/json?q=${queryString}&key=610f77b3d3d24bc384a962a9a35895fb`
      );

      return getCitiesResponse.data.results[0] || {};
    },
    buscarGerenteBlur() {
      if (this.gerenteVendas.cod == '' || this.gerenteVendas.cod == null) {
        this.gerenteVendas.nome = null;
        this.gerenteVendas.email = null;
        this.gerenteVendas.telefone = null;
        this.gerenteVendas.whatsapp = null;
        this.gerenteVendas.cod = null;
        this.Fields.gerenteId = null;
        this.Fields.cadGerente = false;
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('gerente/buscarGerente', this.gerenteVendas.cod)
        .then((response) => {
          this.validGerenteResponse(response);
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao buscar gerente!', 'danger')
        })
        .finally(() => {
          this.$store.dispatch('endLoader')
        });
    },
    buscarGerente() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('gerente/buscarGerente', this.$route.query.gerente)
        .then((response) => {
          this.validGerenteResponse(response);
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    validGerenteResponse(response) {
      if (response.data.gerente == true) {
        const gerente = response.data.data;
        this.gerenteVendas.nome = gerente.nome + ' ' + gerente.sobrenome;
        this.gerenteVendas.email = gerente.email;
        this.gerenteVendas.telefone = gerente.telefone;
        this.gerenteVendas.whatsapp = gerente.whatsapp;
        this.gerenteVendas.cod = gerente.cod;
        this.Fields.gerenteId = gerente.id;
        this.Fields.cadGerente = true;
      } else {
        this.gerenteVendas.nome = null;
        this.gerenteVendas.email = null;
        this.gerenteVendas.telefone = null;
        this.gerenteVendas.whatsapp = null;
        this.gerenteVendas.cod = null;
        this.Fields.gerenteId = null;
        this.Fields.cadGerente = false;
        this.makeToast('Oopss', 'Gerente não encontrado!', 'danger');
      }
    },
    validarCnpj() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('user/validarCnpj', this.Fields.cnpj.replace(/[^0-9]/g, ''))
        .then((response) => {
          if (response.data.valid) {
            this.ErrorMessages.cnpj = 'CNPJ já está sendo utilizado!';
            this.isValidReq = false;
          } else {
            this.ErrorMessages.cnpj = null;
            this.isValidReq = true;
          }
        })
        .catch(() => {
          this.makeToast('Oopss!', 'Tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    validEmail() {
      if (this.Fields.email == '' || this.Fields.email == null) {
        return;
      }

      const data = {
        email: this.Fields.email,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('user/validarEmail', data)
        .then((response) => {
          if (response.data.valid) {
            this.ErrorMessages.email = 'Email já está sendo utilizado!';
            this.isValidEmail = false;
          } else {
            this.ErrorMessages.email = null;
            this.isValidEmail = true;
          }
        })
        .catch(() => {
          this.makeToast('Oopss!', 'Tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    consultCep() {
      if (!this.loading && this.Fields.cep.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.Fields.cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }

      if (this.Fields.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.Fields.endereco = null;
        this.Fields.bairro = null;
        this.Fields.cidade_id = null;
        this.Fields.estado_id = null;
      }
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;

      this.cepConsult.isValidAddress = !!result.logradouro;

      this.cepConsult.isValidNeighborhood = !!result.bairro;

      this.Fields.endereco = result.logradouro || null;
      this.Fields.bairro = result.bairro || null;
      this.Fields.cidade_id = result.cidade_id || null;
      this.Fields.estado_id = result.uf || null;

      this.ErrorMessages.address = null;
      this.ErrorMessages.neighborhood = null;
      this.ErrorMessages.city_id = null;
      this.ErrorMessages.estado_id = null;
    },
    addSegmentoLojista(values) {
      this.ErrorMessages.segmentos = null;
      this.Fields.segmentos = [];
      this.Fields.segmentos.push(...values);
    },
    getNameSegment(id){
      var name = ''  
      this.segmentos.forEach(element => {
        if(element.id == id){
          console.log(element.id)
          console.log(element.nome)
          name = element.nome
        } 
      });
      return name;
    },
    register() {
      this.Fields.tipo_usuario_id = 3;
      if (this.validateFields()) {
        if (this.gerente == true) {
          this.Fields.gerente = true;
          this.Fields.gerenteId = this.gerenteId;
          this.Fields.plano = 3;
        }

        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/register', this.Fields)
          .then((response) => {
            this.$store.dispatch('endLoader');

            if (this.gerente == true) {
              this.makeToast('Sucesso!', 'Lojista cadastrado!', 'success');
              this.$emit('update-lojista');
            } else {
              if(response.data.info && response.data.info.id) {
                this.info = response.data.info;
              }

              const data = {
                id: response.data.id,
                shopkeeperId: response.data.shopkeeperId,
                name: this.Fields.nome_fantasia,
                tipo_usuario_id: 3,
              };
              this.$store.dispatch('createSubAccount', data)
              .then((resp) => console.log(resp));
              this.makeToast('Sucesso!', response.data.message);

              if (this.registerFromItemMenu || this.Fields.novoApp == true) {
                this.$refs.solicitateAppModal.open({
                  shopkeeperId: data.shopkeeperId,
                  info: this.info
                });
                return;
              }

              this.delayedLogin();
            }
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Oopss!', 'email já cadastrado!', 'danger');
            this.$bvModal.show('login');
            localStorage.setItem('emailField', this.Fields.email);
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.$validate.name(this.Fields.razao_social)) {
        this.ErrorMessages.companyName = 'Razão inválida';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_fantasia)) {
        this.ErrorMessages.fantasyName = 'Nome Fantasia inválido';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_responsavel)) {
        this.ErrorMessages.responsibleName = 'Nome do Responsavel inválido';
        isValid = false;
      }

      if (!this.$validate.cnpj(this.Fields.cnpj)) {
        this.ErrorMessages.cnpj = 'CNPJ inválido';
        isValid = false;
      }

      if (!this.$validate.address(this.Fields.endereco)) {
        this.ErrorMessages.address = 'Endereço inválido';
        isValid = false;
      }

      if (!this.$validate.neighborhood(this.Fields.bairro)) {
        this.ErrorMessages.neighborhood = 'Bairro inválido';
        isValid = false;
      }

      if (!this.$validate.cep(this.Fields.cep)) {
        this.ErrorMessages.cep = 'CEP inválido';
        isValid = false;
      }

      if (this.Fields.cidade_id === null) {
        this.ErrorMessages.city = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.Fields.plano === '' && this.gerente == false) {
        this.ErrorMessages.paymentPlan = 'Você não selecionou o plano';
        isValid = false;
      }

      if (!this.Fields.segmentos || this.Fields.segmentos.length == 0) {
        this.ErrorMessages.segmentos = 'Você não selecionou nenhum segmento';
        isValid = false;
      }

      if (this.Fields.estado_id === null) {
        this.ErrorMessages.estado_id = 'Você não selecionou nenhum estado';
        isValid = false;
      }

      if (!this.$validate.addressNumber(this.Fields.numero)) {
        this.ErrorMessages.number = 'Número inválido';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_financeiro)) {
        this.ErrorMessages.name_financial = 'Nome inválido';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email_financeiro)) {
        this.ErrorMessages.email_financial = 'Email de Financeiro inválido';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email)) {
        this.ErrorMessages.email = 'Email inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.celular)) {
        this.ErrorMessages.cellPhone = 'Celular inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.telefone)) {
        this.ErrorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (this.gerente == false) {
        if (!this.$validate.password(this.Fields.password)) {
          this.ErrorMessages.password =
            'A senha precisa ter no mínimo 5 Caracteres';
          isValid = false;
        }

        if (this.Fields.confirm_senha !== this.Fields.password) {
          this.ErrorMessages.confirm_password = 'As senhas devem ser iguais';
          isValid = false;
        }

        if (!this.acceptedTermsAndConditions) {
          this.ErrorMessages.confirmationTerm =
            'Você precisa aceitar os termos e condições';
          isValid = false;
        }
      }

      if (
        this.Fields.telefone2 !== null &&
        this.Fields.telefone2 !== '' &&
        !this.$validate.telephone(this.Fields.telefone2)
      ) {
        this.ErrorMessages.telephone2 = 'Telefone 2 inválido';
        isValid = false;
      }

      if (
        this.Fields.numero_financeiro !== null &&
        this.Fields.numero_financeiro !== '' &&
        !this.$validate.telephone(this.Fields.numero_financeiro)
      ) {
        this.ErrorMessages.number_financial = 'Numero do Financeiro inválido';
        isValid = false;
      }

      return isValid;
    },
    remainingFields() {
      let isValid = true;

      if (this.Fields.razao_social === null) {
        this.ErrorMessages.companyName =
          'Você precisa preencher a razão social da empresa';
        isValid = false;
      }

      if (this.Fields.nome_fantasia === null) {
        this.ErrorMessages.fantasyName =
          'Você precisa preencher o nome fantasia da empresa';
        isValid = false;
      }

      if (this.Fields.nome_responsavel === null) {
        this.ErrorMessages.responsibleName =
          'Você precisa preencher o nome responsável da empresa';
        isValid = false;
      }

      if (this.Fields.endereco === null) {
        this.ErrorMessages.address =
          'Você precisa preencher o endereço da empresa';
        isValid = false;
      }

      if (this.Fields.bairro === null) {
        this.ErrorMessages.neighborhood =
          'Você precisa preencher o bairro da empresa';
        isValid = false;
      }

      if (this.Fields.cep === null) {
        this.ErrorMessages.cep = 'Você precisa preencher o CEP da empresa';
        isValid = false;
      }

      if (this.Fields.cidade_id === null) {
        this.ErrorMessages.city = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.Fields.plano === '') {
        this.ErrorMessages.paymentPlan = 'Você não selecionou o plano';
        isValid = false;
      }

      if (!this.Fields.segmentos || this.Fields.segmentos.length == 0) {
        this.ErrorMessages.segmentos = 'Você não selecionou nenhum segmento';
        isValid = false;
      }

      if (this.Fields.estado_id === null) {
        this.ErrorMessages.estado_id = 'Você não selecionou nenhum estado';
        isValid = false;
      }

      if (this.Fields.numero === null) {
        this.ErrorMessages.number =
          'Você precisa preencher o número da empresa';
        isValid = false;
      }

      if (this.Fields.nome_financeiro === null) {
        this.ErrorMessages.name_financial =
          'Você precisa preencher o nome do responsável financeiro da empresa';
        isValid = false;
      }

      if (this.Fields.email_financeiro === null) {
        this.ErrorMessages.email_financial =
          'Você precisa preencher o email do responsável financeiro da empresa';
        isValid = false;
      }

      if (this.Fields.celular === null) {
        this.ErrorMessages.cellPhone =
          'Você precisa preencher celular da empresa';
        isValid = false;
      }

      if (this.Fields.telefone === null) {
        this.ErrorMessages.telephone =
          'Você precisa preencher o telefone da empresa';
        isValid = false;
      }

      return isValid;
    },
    showContratoPlano(idPlano) {
      this.$bvModal.show(idPlano);
    },
    hideContratoPlano(idPlano) {
      this.$bvModal.hide(idPlano);
    },
    logger(value) {
      this.specialRegister = false;
      this.isSpecialRegistering = false;
      this.Fields.link_referencia =
        process.env.VUE_APP_CURRENT_SITE_ADDRESS + this.$route.fullPath;

      // Obrigatório
      this.Fields.cnpj = value.cnpj;
      this.Fields.razao_social = value.razao_social;

      // Financeiro
      this.Fields.nome_financeiro = value.nome_financeiro;
      this.Fields.email_financeiro = value.email_financeiro;
      this.Fields.email = value.email;
      this.Fields.numero_financeiro = value.numero_financeiro;
      this.Fields.ramal_financeiro = value.ramal_financeiro;

      // Nomes
      this.Fields.nome_fantasia = value.nome_fantasia;
      this.Fields.nome_responsavel = value.nome_responsavel;

      // Contato
      this.Fields.numero = value.numero;
      this.Fields.celular = value.celular;
      this.Fields.telefone = value.telefone;
      this.Fields.telefone2 = value.telefone2;

      // Endereço
      this.Fields.cep = value.cep;
      this.Fields.endereco = value.endereco;
      this.Fields.bairro = value.bairro;
      this.Fields.complemento = value.complemento;

      this.remainingFields();
    },
    delayedLogin() {
      setTimeout(() => {
        this.login(this.Fields.email, this.Fields.password, false, true);
      }, 1000);
    }, 
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosApp')
      .then((response) => {
        this.planosApp = response.data;
        this.$store.dispatch('endLoader');
      })
    },
    showPlanosId() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosAppId', this.Fields.plano_id)
      .then((response) => {
        this.planosApp = response.data;
        this.$store.dispatch('endLoader');
      })
    },
  },
};
</script>
<style scoped>
.no-search .vs_search {
  background: transparent;
}

div.form-group label {
  font-weight: 700;
}

div.col-12 label {
  font-weight: 700;
}

.videoYoutube {
  text-align: center;
}
.planos {
  width: 200px;
  margin-right: 200px;
}
.opc {
  font-size: 0.7rem;
  color: #afafaf;
  position: relative;
  top: -5px;
  left: 5px;
}
.obgt {
  color: red;
}
.btn-larg {
  width: 100%;
  height: 50px;
}
.location {
  float: right;
  text-decoration: underline;
  cursor: pointer;
  color: blue
}
@media only screen and (max-width: 768px) {
  .planos {
    width: 200px;
    margin-right: 20px;
  }
  .videoYoutube {
    width: 70%;
  }
  iframe {
    width: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .videoYoutube {
    width: 100%;
  }
  iframe {
    width: 100%;
  }
}
</style>
